/* eslint-disable react-refresh/only-export-components */
import type { Person } from '@/store/people/types';
import { createContext, useContext, useState, type ReactNode } from 'react';
import { CommentModal } from './modal';

export interface CommentModalState {
  open: boolean;
  setOpen: (value: boolean) => void;
  currentPerson: Person | null;
  setCurrentPerson: (value: Person | null) => void;
}

const CommentModalContext = createContext({} as CommentModalState);

export function CommentModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [currentPerson, setCurrentPerson] = useState<Person | null>(null);
  const state: CommentModalState = {
    open,
    setOpen,
    currentPerson,
    setCurrentPerson,
  };

  return (
    <CommentModalContext.Provider value={state}>
      <>
        <CommentModal
          isOpen={open}
          onOpenChange={setOpen}
          subject={currentPerson}
        />
        {children}
      </>
    </CommentModalContext.Provider>
  );
}

export function useCommentModal() {
  return useContext(CommentModalContext);
}
